import dayjs from 'dayjs';

export const getLastUpdatedText = (updatedAt: string, name: string) => {
    const timeOffsetMin = dayjs(updatedAt).utcOffset();
    const relativeUpdatedAt = dayjs(updatedAt).add(timeOffsetMin, 'minutes');
    const timeSinceLastUpdate = dayjs(relativeUpdatedAt).fromNow();
    const lastUpdatedText = `Last Updated: ${timeSinceLastUpdate} by ${name}`;
    return lastUpdatedText;
};
